import { useUserStore } from "../store";
const useIsVerified = () => {
  const user = useUserStore((state) => state.user);
  return !!user?.idOis && user.oisAuthIsActive;
};

export default useIsVerified;
